import React from "react";
import {
  Area,
  AreaChart,
  Bar,
  BarChart,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import "./Dashbord.css";

const Dashbord = () => {
  const data = [
    {
      name: "Page A",
      price: 4000,
      sales: 2400,
      amt: 2400,
    },
    {
      name: "Page B",
      price: 3000,
      sales: 1398,
      amt: 2210,
    },
    {
      name: "Page C",
      price: 2000,
      sales: 9800,
      amt: 2290,
    },
    {
      name: "Page D",
      price: 2780,
      sales: 3908,
      amt: 2000,
    },
    {
      name: "Page E",
      price: 1890,
      sales: 4800,
      amt: 2181,
    },
    {
      name: "Page F",
      price: 2390,
      sales: 3800,
      amt: 2500,
    },
    {
      name: "Page G",
      price: 3490,
      sales: 4300,
      amt: 2100,
    },
  ];
  return (
    <div className="charts">
      <div>
        <LineChart
          width={400}
          height={200}
          data={data}
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <Line dataKey={"price"}></Line>
          <Line dataKey={"sales"}></Line>
          <XAxis dataKey="name"></XAxis>
          <YAxis></YAxis>
          <Tooltip></Tooltip>
        </LineChart>
      </div>

      <div>
        <AreaChart
          width={400}
          height={200}
          data={data}
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <linearGradient
            id="colorUv"
            x1="0"
            y1="0"
            x2="0"
            y2="1"
          ></linearGradient>
          <defs>
            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="name" />
          <YAxis />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <Area
            type="name"
            dataKey="price"
            stroke="#8884d8"
            fillOpacity={1}
            fill="url(#colorUv)"
          />
          <Area
            type="amt"
            dataKey="sales"
            stroke="#82ca9d"
            fillOpacity={1}
            fill="url(#colorPv)"
          />
        </AreaChart>
      </div>

      <div>
        <BarChart width={530} height={250} data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="price" fill="#8884d8" />
          <Bar dataKey="sales" fill="#82ca9d" />
        </BarChart>
      </div>

      <div>
        <ComposedChart width={530} height={250} data={data}>
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <CartesianGrid stroke="#f5f5f5" />
          <Area type="monotone" dataKey="amt" fill="#8884d8" stroke="#8884d8" />
          <Bar dataKey="sales" barSize={20} fill="#413ea0" />
          <Line type="monotone" dataKey="price" stroke="#ff7300" />
        </ComposedChart>
      </div>
    </div>
  );
};

export default Dashbord;
